import React from 'react';
import Logo from '../assets/images/logo-bullcapital-2x.png';
import { BoxArrowLeft, House, People } from 'react-bootstrap-icons';
import { Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { removeTokens } from '../utils/auth.utils';
import api from '../services/api';

const SideNav: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const fetchAdminLogout = async () => {
      try {
        await api.delete('auth/admins/logout');
      } catch (error) {
        console.error('Error executing admin logout:', error);
      }
    };
    await fetchAdminLogout();
    removeTokens();
    navigate('/');
  };
  return (
    <Col md={3} className="sidebar d-flex flex-column align-items-center p-4">
      <img src={Logo} alt="Bell Capital MX" className="img-fluid" style={{ maxWidth: '50%' }} />
      <ul className="menu-list mt-4">
        <li>
          <Link to="/dashboard">Dashboard</Link>
          <House />
        </li>
        <li>
          <Link to="/dashboard/customers">Clientes</Link>
          <People />
        </li>
        <li>
          <Link to="#" onClick={async (e) => await handleLogout(e)}>
            Salir
          </Link>
          <BoxArrowLeft />
        </li>
      </ul>
    </Col>
  );
};

export default SideNav;
